<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento dos Pedágios.</span>
                <br />
                <span class="navigation">Cadastros > Pedágios</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" maxlength="500" v-model="Pedagio.nome" />
                </span>
                <small v-show="validationErrors.nome" class="p-error">Nome é Obrigatório.</small>
              </div>
            </div>
            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/pedagioListagem">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import Pedagio from "../models/nfse/Pedagio";
import PedagioService from '../services/nfse/pedagio.service';

export default {
  name: "PedagioCadastro",
  data() {
    return {
      money: money,
      currentUser: null,
      loading: false,
      Pedagio: new Pedagio(),
      validationErrors: {},
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.PedagioId = this.$route.params.id;

    if (this.PedagioId != null) {
      setTimeout(async () => {
        await PedagioService.getPedagio(this.PedagioId).then(
          response => {
            this.Pedagio = response.data;
          },
          error => {
            let errorMessage = "Houve um problema ao buscar o Pedágio!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
      }, 250);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.salvar();
      this.loading = false;
    },
    salvar() {
      this.Pedagio.idCliente = this.currentUser.usuario.idCliente;      
      PedagioService.save(this.Pedagio).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Pedágio salvo com sucesso"
          });
          this.$router.push("pedagioListagem");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar o Emolumento!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    editarTipo() {
      this.$root.$emit("emolumento:novoTipo", this.currentUser.usuario.idCliente);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 3px;
}
</style>